export var Cache;
(function (Cache) {
})(Cache || (Cache = {}));
//# sourceMappingURL=Cache.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/apollo-cache/lib/types/Cache.js
// module id = 2044
// module chunks = 0